import React, { useState, useEffect } from "react";
import "./CookiesBanner.scss";

const COOKIE_NAME = "cookieConsent";

const getCookie = (name) => {
  const match = document.cookie.match(`(?:^|;\\s*)${name}=([^;]*)`);
  return match ? decodeURIComponent(match[1]) : null;
};

const setCookie = (name, value, days) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires}; path=/; SameSite=Lax`;
};

const getStoredConsent = () => {
  return getCookie(COOKIE_NAME) || localStorage.getItem(COOKIE_NAME);
};

const persistConsent = (value) => {
  setCookie(COOKIE_NAME, value, 365);
  localStorage.setItem(COOKIE_NAME, value);
};

const CookiesBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getStoredConsent()) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    persistConsent("accepted");
    setVisible(false);
  };

  const handleReject = () => {
    persistConsent("rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookies-banner-overlay">
      <div className="cookies-banner-wrapper">
        <div className="cookies-banner">
          <div className="cookies-banner-body">
            <div className="cookies-banner-icon">
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="10" fill="#59A638" />
                <circle cx="9" cy="9" r="1.5" fill="#fff" />
                <circle cx="15" cy="8" r="1.2" fill="#fff" />
                <circle cx="12" cy="14" r="1.8" fill="#fff" />
                <circle cx="8" cy="14" r="1" fill="#fff" />
                <circle cx="15" cy="13" r="1" fill="#fff" />
              </svg>
            </div>
            <div className="cookies-banner-text">
              <h4>We Value Your Privacy</h4>
              <p>
                We use cookies to ensure our application functions securely,
                remember your preferences, and improve your experience.
                Essential cookies are always active because they are necessary
                for the application to operate. With your consent, we may also
                use non-essential cookies to analyze usage and enhance our
                services. You can choose to accept all cookies or reject all
                cookies.
              </p>
            </div>
          </div>
          <div className="cookies-banner-actions">
            <button
              type="button"
              className="cookies-btn cookies-btn-accept"
              onClick={handleAccept}
            >
              Accept All
            </button>
            <button
              type="button"
              className="cookies-btn cookies-btn-reject"
              onClick={handleReject}
            >
              Reject All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiesBanner;
